import { useTranslation } from "react-i18next";

import { Arrange, Typography, Box } from "@aviary";
import qualityProgramPoster from "@emerson/assets/images/homepage/quality_program_poster.png";
import { l } from "@emerson/locales/i18n";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

import * as styles from "./QualityProgram.styles";
const QualityProgram = () => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();

  return (
    <Box accentColor="forest" padding="large">
      <div css={[styles.qualityProgramWrapper, !tablet.greaterThan && styles.mobileWrapper]}>
        <div css={!!tablet.greaterThan && styles.qualityProgramColum}>
          <img
            css={styles.fullWidthImage}
            src={qualityProgramPoster}
            alt="Emerson Quality Program Image"
          />
        </div>
        <div css={!!tablet.greaterThan && styles.qualityProgramColum}>
          <Arrange isFullWidth isVertical>
            <Typography type="h3">{t(l.qualityProgram.Title)}</Typography>
            <Typography type="body">{t(l.qualityProgram.Description)}</Typography>
            <ul css={styles.unorderedList}>
              <li>
                <Typography type="body">{t(l.qualityProgram.List.ListItem1)}</Typography>
              </li>
              <li>
                <Typography type="body">{t(l.qualityProgram.List.ListItem2)}</Typography>
              </li>
              <li>
                <Typography type="body">{t(l.qualityProgram.List.ListItem3)}</Typography>
              </li>
            </ul>
          </Arrange>
        </div>
      </div>
    </Box>
  );
};

export { QualityProgram };
